/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
window.PXUTheme.jsVideo = {
  init: function ($section) {

    // Add settings from schema to current object
    window.PXUTheme.jsVideo = $.extend(this, window.PXUTheme.getSectionData($section));

    // Selectors
    const $videoElement = $section.find('[data-video-element]');
    const $playIcon = $section.find('.plyr--paused.plyr--video .plyr__control--overlaid');
    const $playButton = $section.find('[data-play-button]');
    const $videoTextContainer = $section.find('[data-video-text-container]');
    const $imageElement = $section.find('[data-image-element]');

    // Load video if the media has been added
    if (this.iframe_video || this.html5_video || this.html5_video_mobile) {
      this.loadVideo($section, $videoElement, $playIcon, $playButton, $videoTextContainer, $imageElement);
    } else {
      $imageElement.show();
    }

  },
  // Resolve desktop or mobile settings, falling back to desktop when mobile is not set
  getBreakpointSettings: function(settings, isMobile) {
    let autoplay = settings.autoplay;
    let mute = settings.mute;
    let aspectRatio = settings.aspect_ratio;
    let poster = settings.poster;
    let videoSrc = settings.html5_video || settings.html5_video_mobile;

    if (isMobile) {
      poster = settings.poster_mobile || poster;
      videoSrc = settings.html5_video_mobile || videoSrc;

      if (settings.aspect_ratio_mobile && settings.aspect_ratio_mobile !== 'same') {
        aspectRatio = settings.aspect_ratio_mobile;
      }

      if (settings.autoplay_mobile === 'on') {
        autoplay = true;
      } else if (settings.autoplay_mobile === 'off') {
        autoplay = false;
      }
    }

    // Browsers only allow muted autoplay
    if (autoplay) {
      mute = true;
    }

    return { autoplay, mute, aspectRatio, poster, videoSrc };
  },
  loadVideo: function($section, $videoElement, $playIcon, $playButton, $videoTextContainer, $imageElement) {
    // Copy settings, as this object is shared between all video sections
    const settings = $.extend({}, this);
    const largeScreen = window.PXUTheme.media_queries.large;
    const $html5Source = $videoElement.find('source[data-src-desktop]');
    let current = this.getBreakpointSettings(settings, !largeScreen.matches);

    if ($html5Source.length) {
      $html5Source.attr('src', current.videoSrc);
      $html5Source.closest('video')[0].load();
    }

    const player = new Plyr(`.video-${this.id}`, {
      controls: videoControls,
      // Play inline on iOS instead of opening the native fullscreen player
      playsinline: true,
      // Plyr only reads autoplay/muted on setup, so pass them here
      autoplay: current.autoplay,
      muted: current.mute,
      loop: {
        active: this.autoloop
      },
      fullscreen: {
        enabled: true,
        fallback: true,
        iosNative: true
      },
      storage: {
        enabled: false
      }
    });

    player.muted = current.mute;
    player.ratio = current.aspectRatio;

    const showInitialState = (state) => {
      if (state.autoplay) {
        // If autoplay enabled, hide image and text
        $imageElement.hide();
        $videoTextContainer.hide();
        $videoElement.show();
      } else if (state.poster) {
        // If autoplay disabled, check if poster image added
        $videoElement.hide();
        $imageElement.show();
        $videoTextContainer.show();
      } else {
        // If autoplay disabled and no poster image
        $imageElement.hide();
        $videoElement.show();
        $videoTextContainer.show();
      }
    };

    showInitialState(current);

    // Re-apply desktop/mobile settings when crossing the breakpoint (resize, rotate, theme editor preview)
    const onBreakpointChange = () => {
      const next = this.getBreakpointSettings(settings, !largeScreen.matches);

      if ($html5Source.length && next.videoSrc !== current.videoSrc) {
        $html5Source.attr('src', next.videoSrc);
        player.media.load();
      }

      player.muted = next.mute;
      player.ratio = next.aspectRatio;
      player.autoplay = next.autoplay;

      if (next.autoplay) {
        const playPromise = player.play();
        if (playPromise && playPromise.catch) {
          playPromise.catch(() => {});
        }
      } else {
        player.pause();
      }

      showInitialState(next);
      current = next;
    };

    largeScreen.addListener(onBreakpointChange);
    $section.data('video-breakpoint-handler', onBreakpointChange);

    // If button exists, clicking button will play video
    if (this.button) {
      $playButton.on('click', () =>  {
        player.play();
      })
    }

    // Clicking anywhere on video should play the video
    if (!this.button) {
      $videoTextContainer.on('click', () => {
        player.play();
      })
    }

    // If on mobile and text is below image, clicking the image wrapper should play the video
    if (!isScreenSizeLarge() && $videoElement.parents('.mobile-text--below-media')) {
      $imageElement.on('click', () => {
        player.play();
      })
    }

    // On player ready, hide play icon if play button visible
    player.on('ready', function(index, player) {
      if ($playButton && !isScreenSizeLarge() && $videoElement.parents('.mobile-text--below-media')) {
        $playIcon.show();
      } else if ($playButton) {
        $playIcon.hide();
      } else {
        $playIcon.show();
      }
    })

    // On play, hide image/text and show video element
    player.on('play', function(index, player) {
      $videoElement.show();
      $imageElement.hide();
      $videoTextContainer.hide();
    })

    // On player pause, show play icon if play button hidden
    player.on('pause', function(index, player) {
      if (!$playButton) {
        $playIcon.show();
      }
    })

  },
  unload: function($section) {
    const $playButton = $section.find('[data-play-button]');
    const $videoTextContainer = $section.find('[data-video-text-container]');
    const onBreakpointChange = $section.data('video-breakpoint-handler');

    $playButton.off();
    $videoTextContainer.off();

    if (onBreakpointChange) {
      window.PXUTheme.media_queries.large.removeListener(onBreakpointChange);
      $section.removeData('video-breakpoint-handler');
    }
  }
}

/******/ })()
;
